// frontend/src/filterCConstants.js
export const FILTER_OPTIONS = {
  RISK_LEVELS: [
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" },
    { value: "very_high", label: "Very High" },
  ],

  STATUSES: [
    { value: "pending_gov_approval", label: "Pending" },
    { value: "active", label: "Active" },
    { value: "rejected", label: "Rejected" },
    { value: "liquidated", label: "Liquidated" },
    { value: "resigned", label: "Resigned" },
  ],

  LEGAL_FORMS: [
    { value: "SPF", label: "SPF" },
    { value: "Ltd", label: "Ltd" },
    { value: "Association", label: "Association" },
    { value: "B.V.", label: "B.V." },
    { value: "C.V.", label: "C.V." },
    { value: "Foundation", label: "Foundation" },
    { value: "LLC", label: "LLC" },
    { value: "LLP", label: "LLP" },
    { value: "N.V.", label: "N.V." },
    { value: "Partnership", label: "Partnership" },
    { value: "PLC", label: "PLC" },
    { value: "Private Foundation", label: "Private Foundation" },
    { value: "Sole Proprietorship", label: "Sole Proprietorship" },
    { value: "Trust", label: "Trust" },
    { value: "Other", label: "Other" },
  ],

  RESIDENCY_STATUS: [
    { value: "local", label: "Local" },
    { value: "international", label: "International" },
    { value: "foreign", label: "Foreign" },
  ],

  // ✅ NEW: Management company options
  MANAGED_BY: [
    { value: "gtrust", label: "G-Trust Curaçao B.V." },
    { value: "prostaff", label: "ProStaff Curacao N.V." },
  ],
};

// Helper function to map status values to display labels
export const getStatusLabel = (status) => {
  const statusItem = FILTER_OPTIONS.STATUSES.find((s) => s.value === status);
  return statusItem ? statusItem.label : status;
};

// ✅ NEW: Helper function to map managed_by values to display labels
export const getManagedByLabel = (managedBy) => {
  const item = FILTER_OPTIONS.MANAGED_BY.find((m) => m.value === managedBy);
  return item ? item.label : managedBy;
};
